import { useCallback, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";
import { withAuthRetry } from "../lib/authState";

export function useProfile() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(undefined);

  const refresh = useCallback(async () => {
    if (!user) return;
    const cached = JSON.parse(localStorage.getItem(`dropit-profile-${user.id}`) || "null");
    if (cached) setProfile((p) => p ?? cached);
    const { data, error } = await withAuthRetry(() => supabase.from("profiles").select("*").eq("id", user.id).maybeSingle());
    if (error) { if (!cached) setProfile(user.cached ? { id: user.id, full_name: user.user_metadata?.full_name || "—" } : undefined); return; }
    setProfile(data ?? null); if (data) localStorage.setItem(`dropit-profile-${user.id}`, JSON.stringify(data));
    heartbeat(data);
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  // Activity heartbeat: once per 24 h; also cancels a scheduled inactivity deletion (banner shown via `welcomeBack`).
  const [welcomeBack, setWelcomeBack] = useState(false);
  const heartbeat = async (data) => {
    if (!data || !navigator.onLine) return;
    const key = `dropit-heartbeat-${user.id}`;
    const scheduled = !!data.deletion_scheduled_at;
    if (!scheduled && Date.now() - Number(localStorage.getItem(key) || 0) < 86400e3) return;
    const patch = { last_active_at: new Date().toISOString(), ...(scheduled ? { deletion_scheduled_at: null, deletion_warned_at: null } : {}) };
    const { error } = await supabase.from("profiles").update(patch).eq("id", user.id);
    if (!error) { localStorage.setItem(key, String(Date.now())); if (scheduled) setWelcomeBack(true); }
  };

  useEffect(() => { refresh(); }, [refresh]);

  const save = async (fields) => {
    const { error } = await supabase.from("profiles").update(fields).eq("id", user.id);
    if (error) throw error;
    await refresh();
  };
  const saveName = (full_name, phone) => save(phone ? { full_name, phone } : { full_name });

  return { profile, saveName, save, welcomeBack, dismissWelcomeBack: () => setWelcomeBack(false) };
}
